import { createContext } from 'react';

export const AppAuthContext = createContext('');
